/* eslint-env jquery */
const $ = jQuery.noConflict();
import storeMap from './storeMap';
import Reseller from './reseller';
import formHelpers from './formHelpers';
'use strict';
const FindStore = {

	$domLoaderSearch: $('.js-map-drop__drop-loader'),
	$domMapDropContent: $('.js-map-drop__content'),
	classDropShow: 'map-drop-show',


	/*-------------------------------------------------------------------------------
		# Initialize
	-------------------------------------------------------------------------------*/
	init: function() {
		this.mapTrigger() || this.search();
		this.getStoreId();
		$('.map-drop__search-wrap-loader').hide();
	},

	mapTrigger: function() {
		$('.js-search-store').click(() => {
			if ($('.js-option-hidden').is(':selected')) {
				const error = document.getElementById('select-error');
				if (error) {
					error.textContent = 'Please select radius.';
				}
				$('.js-map-drop__content').hide();
			} else {
				FindStore.doSearch();
				$('#select-error').empty();
			}
		});
	},

	doSearch() {
		const zipUser = $('.js-search-store-input').val();
		const postId = $('.js-search-store').attr('data-cat');
		$('.js-option-select').each(function(key, value) {
			if ($(value).hasClass('is-active')) {
				FindStore.text = value.text;
			}
		});
		this.findStore(zipUser, postId, FindStore.text);
	},

	search: function() {
		$('.js-search-store-input').on('keyup', (e) => {
			if (e.key === 'Enter' || e.keyCode === 13) {
				if ($('.js-option-hidden').is(':selected')) {
					const error = document.getElementById('select-error');
					if (error) {
						error.textContent = 'Please select radius.';
					}
					$('.js-map-drop__content').hide();
				} else {
					FindStore.doSearch();
					$('#select-error').empty();
				}
			}
		});
	},

	findStore: function(zipUser, postId, text) {
		$('.map-drop__search-wrap-loader').show();
		$.ajax({
			type: 'POST',
			// eslint-disable-next-line no-undef
			url: mongotelAjax.ajaxUrl,
			// eslint-disable-next-line no-undef,camelcase
			data: {
				action: 'map_drop',
				// eslint-disable-next-line camelcase
				search_stores: $('.js-search-store-input').val(),
				// eslint-disable-next-line camelcase
				zip: zipUser,
				postId: postId,
				text: text
			},
			success: function(response) {
				$('.map-drop__search-wrap-loader').hide();
				$('.map-drop').find(Reseller.$domMapDropContent).addClass(Reseller.classDropShow);
				$('#error').empty();
				$('.js-map-drop-object').empty();
				$('.js-map-drop__content').css('display', 'block');

				$.each(response.html, function(key, card) {
					$('.js-map-drop-object').append(card);
				});

				$('.wpcf7-form').each(function() {
					/* eslint-disable no-undef */
					wpcf7.initForm($(this));
				});
				Reseller.init();
				formHelpers.init();
				storeMap.addMarkersFromResponse(response.markers);
				$('.js-map-drop-object').show();
			},
			error: function() {
				console.clear();
				$('.js-map-drop-object').hide();
				console.clear();
				$('.js-map-drop__content').hide();
				console.clear();
				$('.map-drop__search-wrap-loader').hide();
				console.clear();
				const error = document.getElementById('error');
				console.clear();
				if (error) {
					console.clear();
					error.textContent = 'No results found.';
					console.clear();
				}
				console.clear();
			}
		});
	},

	getStoreId: function() {
		$('.js-click-store').on('click', function() {
			$('.js-get-store-id').each(function(key, value) {
				if ($(value).hasClass('map-drop-active')){
					FindStore.postId = $(value).attr('data-store-id');
					FindStore.postValue = $('input.wpcf7-form-control.wpcf7-hidden').attr('value', FindStore.postId);
				}
			});
		});
	}
};

export default FindStore;
